/**
 * Runs `run` on the first pointer, key, or (optionally) scroll.
 * The timer is a fallback for people who never interact — it is intentionally
 * long so lab runs that end after a few seconds of network quiet never see it.
 * Do not use requestIdleCallback here: the page goes idle right after hydrate,
 * which pulls this work back onto the critical path.
 */
export const NONCRITICAL_FALLBACK_MS = 15000

export const runOnInteractionOrTimeout = (
  run: () => void,
  options: { fallbackMs?: number; includeScroll?: boolean } = {}
) => {
  const fallbackMs = options.fallbackMs ?? NONCRITICAL_FALLBACK_MS
  let ran = false
  let timeoutId = 0

  const cleanup = () => {
    window.clearTimeout(timeoutId)
    window.removeEventListener('pointerdown', fire)
    window.removeEventListener('keydown', fire)
    if (options.includeScroll) {
      window.removeEventListener('scroll', fire)
    }
  }

  function fire() {
    if (ran) return
    ran = true
    cleanup()
    run()
  }

  timeoutId = window.setTimeout(fire, fallbackMs)
  window.addEventListener('pointerdown', fire, { once: true, passive: true })
  window.addEventListener('keydown', fire, { once: true })
  if (options.includeScroll) {
    window.addEventListener('scroll', fire, { once: true, passive: true })
  }

  return cleanup
}
